import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useGetClientRequirements = () => {
  const {
    data: clientRequirements,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<string[]>((response) => response);

  const getClientRequirements = async (clientName: string) => {
    await call(`/admin/llm/clients/${clientName}/requirements`, "GET");
  };

  return {
    clientRequirements,
    getClientRequirements,
    isLoading,
    isFailed,
  };
};
